import React, {useState} from "react";
import {useLazyQuery, useMutation, useSubscription} from "@apollo/client";
import {Box, Grommet, Text, Layer} from "grommet";
import {DataGrid} from "@mui/x-data-grid";
import {tenant, tenantType} from "../tenant.js";
import {Divider, IconButton, Tooltip} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";
import {DELETE_MOVEMENT, DELETE_PRODUCT, GET_MOVEMENTS, GET_PRODUCTS, UPSERT_PRODUCT} from "./ProductGQL.jsx";
import moment from "moment";
import {colors, dataGridStyles, layerStyles} from "../../utilis/theme.js";
import ConfirmDialog from "../common/ConfirmDialog.jsx";

function MovementList(props){

    const [movements,setMovements] = React.useState([]);
    const [deleteMovement]=useMutation(DELETE_MOVEMENT)
    const [ queryGetMovement
    ] = useLazyQuery(GET_MOVEMENTS, {
    fetchPolicy: "no-cache",
    onCompleted: (data) => {
        const movements=data[`${tenant}_products_movement`];
        if(movements){
            let movementsApp=[];
            for(let i=0;i<movements.length;i++){
                movementsApp.push({...movements[i],data:moment(movements[i].data).format("DD-MM-YYYY HH:mm"),area:movements[i][`area_area${tenantType}`]?.name})
            }
            setMovements(movementsApp);
        }
    },
    notifyOnNetworkStatusChange: true, // did the work
  });
    const [deletedMovement,setDeletedMovement] = useState(false);
    const [confirmDialog, setConfirmDialog] = useState({open: false, movementId: null});

    function getMovements(){
        queryGetMovement({variables:{productId:props?.prodSel?.id}})
            .then((value)=>console.log("VALUE",value))
            .catch((err)=>console.log("ERR",err));
    }

    const columnsMovements = [
    { field: 'data', headerName: 'Data', flex: 1, minWidth: 160 },
    { field: 'user', headerName: 'Effettuato da', flex: 1, minWidth: 150,
         renderCell: (cellValues) => {
            return(
                <Text size={"small"}>{cellValues.row[`users_user${tenantType}`]["name"]} {cellValues.row[`users_user${tenantType}`]["surname"]}</Text>
            )
         }
    },
    { field: 'quantity', headerName: 'Quantità', flex: 0.5, minWidth: 100,
         renderCell: (cellValues) => {
            return(
                <Text weight="bold">{Math.abs(cellValues.row.quantity)}</Text>
            )
         }
    },
    { field: 'area', headerName: 'Area', flex: 0.7, minWidth: 120 },
    {
      field: 'azioni',
      headerName: '',
      width: 60,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (cellValues) => {
        return (
          <Tooltip title="Cancella" arrow>
            <IconButton
              color="error"
              size="small"
              onClick={() => setConfirmDialog({open: true, movementId: cellValues.row.id})}
            >
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        );},
    },
  ];

  function onEscLayer(){
    if(props.onEscLayer){
        props.onEscLayer();
        if(deletedMovement && props.getProducts){
            props.getProducts();
        }
    }
  }


  React.useEffect(()=>{
     getMovements();
  },[props?.prodSel])


    return (
        <Layer onEsc={onEscLayer} onClickOutside={onEscLayer} style={{width:'75vw', maxHeight:'70vh', ...layerStyles.dialog}}>
            <Box background="white" round="16px" overflow="hidden" fill>
                <Box pad={{horizontal:'medium', top:'medium', bottom:'small'}} direction="row" align="center" justify="between" flex={false}>
                  <Text color={colors.primary} size="large" weight="bold">MOVIMENTI PER {props?.prodSel?.name}</Text>
                  <IconButton size="small" onClick={onEscLayer}>
                    <CloseIcon fontSize="small" style={{color:colors.border}} />
                  </IconButton>
                </Box>
                <Divider style={{margin:0}} />
                <Box pad="medium" overflow="auto" flex>
                    <div style={{ height: '50vh', width: '100%' }}>
                      <DataGrid
                        rows={movements || []}
                        columns={columnsMovements}
                        getRowClassName={(params) =>
                            params.row.quantity >= 0 ? 'row-carico' : 'row-scarico'
                        }
                        sx={{
                          ...dataGridStyles.base,
                          '& .row-carico': {
                            backgroundColor: colors.successLight,
                            '&:hover': { backgroundColor: colors.successHover },
                          },
                          '& .row-scarico': {
                            backgroundColor: colors.errorLight,
                            '&:hover': { backgroundColor: colors.errorHover },
                          },
                        }}
                      />
                    </div>
                </Box>
            </Box>
            <ConfirmDialog
                open={confirmDialog.open}
                onClose={() => setConfirmDialog({open: false, movementId: null})}
                onConfirm={() => {
                    setDeletedMovement(true);
                    deleteMovement({variables:{movementId:confirmDialog.movementId}});
                    getMovements();
                }}
                message="Sei sicuro di voler eliminare il movimento selezionato?"
                type="delete"
                confirmLabel="Elimina"
            />
        </Layer>
    )
}

export default MovementList;

